import { render } from "./Loan_Settlements.vue?vue&type=template&id=b70c12de"
import script from "./Loan_Settlements.vue?vue&type=script&lang=js"
export * from "./Loan_Settlements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__